module.exports = __webpack_public_path__ + "img/drag-icon.e2d8e296.svg";